import * as React from 'react';
import * as styles from './Layout.css';

interface ILayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: ILayoutProps) => <div className={styles.section}>{children}</div>;

const Title = ({ children }: ILayoutProps) => <div className={styles.title}>{children}</div>;

const Content = ({ children }: ILayoutProps) => <div className={styles.content}>{children}</div>;

Layout.Title = Title;
Layout.Content = Content;
